import React, { useState } from "react";
import Background from "../../../Pages/Background";
import { Flex, Box, VStack, Button, Heading, HStack } from "@chakra-ui/react";
import { COLORS } from "../../../Helper/Colors";
import { ProfileDetails } from "./ProfileDetails";
import { Pencil } from "phosphor-react";
import { EditProfileDetails } from "./EditProfileDetails";
import { BackButton } from "../UI";
import { useSelector } from "react-redux";
import Api from "../../../Helper/ApiHandler";
import PageLoader from "../PageLoader";

const ProfileSettings = ({  }) => {
	const api = new Api();
	let loginData = useSelector((state) => state.loginData);
	const [update, setUpdate] = useState(false);

	const [loading, setLoading] = useState(false);
	const handleEdit = () => {
		setUpdate(true);
	};

	return (
		<Flex height={"100vh"}>	
			<Box
				display={"flex"}
				flexDirection={"column"}
				width={"100%"}
				height={"100%"}
				overflow={"hidden"}
			
			>
				<Background showCalendar={true} heading={"My Profile"} key='Profile & settings'>
					<VStack
						spacing={8}
						alignItems={"self-start"}
						backgroundColor={COLORS.light}
						padding='2rem'
						borderRadius='10px'
						height={"100%"}
						overflow={"auto"}
						className='design-scrollbar'
						zIndex={1}
					>
						<Flex
							width={"100%"}
							alignItems={"center"}
							justifyContent={"space-between"}
							// position={"sticky"}
							zIndex={1000}
							top={0}
							backgroundColor={COLORS.light}
						>
							<HStack alignItems={"center"} spacing={2}>
								{update && (
									<BackButton
										size={22}
										color={COLORS.dark}
										bgColor={"transparent"}
										_hover={{}}
										_focus={{}}
										_active={{}}
										onClick={() => setUpdate(false)}
									/>
								)}
								<Heading as='h3' size='md' color={COLORS.dark} fontFamily={"inherit"} textTransform={"capitalize"}>
									{!update ? "Profile" : "Edit Profile"}
								</Heading>
							</HStack>
							{!update && (
								<Button
									size='lg'
									type='submit'
									colorScheme={"brand"}
									leftIcon={<Pencil size={22} />}
									margin={2}
									variant='ghost'
									color={COLORS.brand}
									onClick={handleEdit}
									fontWeight={"medium"}
								>
									Edit Profile
								</Button>
							)}
						</Flex>
						{!!loading && <PageLoader isLoading={loading} spinnerColor={null} />}
						{!update && !loading && <ProfileDetails profileData={loginData}  />}
						{!!update && !loading && <EditProfileDetails profileData={loginData} setUpdate={setUpdate} />}
					</VStack>
				</Background>
			</Box>
		</Flex>
	);
};

export default ProfileSettings;
